import type {
  QuestionnaireFormFieldConfig,
  QuestionnnaireFormFieldAnswer,
} from '../lib/form-types';
import { flattenFields, getFilteredConfig } from './fields';

export function projectVisibleAnswers<Answer extends QuestionnnaireFormFieldAnswer>(
  config: readonly QuestionnaireFormFieldConfig[],
  answers: readonly Answer[],
) {
  let retainedAnswers = answers;
  for (;;) {
    const fields = flattenFields(getFilteredConfig(config, retainedAnswers));
    const fieldNames = new Set(fields.map((field) => field.name));
    const visibleAnswers = retainedAnswers.filter((answer) => fieldNames.has(answer.field_name));
    if (visibleAnswers.length === retainedAnswers.length) {
      return { fields, answers: visibleAnswers };
    }
    retainedAnswers = visibleAnswers;
  }
}
